export enum ResultEnum {
  SUCCESS = 200,
}
